import styled from "styled-components";
import { IPagesStyle } from "./types_Applicants";

const ListItem = styled.li.attrs<IPagesStyle>((props) => ({
  className: `${props.active && "!text-black underline"} 
  text-neutral-300 hover:text-black active:text-black cursor-pointer font-bold`,
}))<IPagesStyle>``;

const DatosContainer = styled.div.attrs({
  className:
    "w-full bg-neutral-100 rounded-lg flex flex-col lg:flex-row flex-wrap px-8 pt-12 pb-12 lg:pb-14 mb-8",
})``;

const InfoGrouping = styled.div.attrs({
  className: "flex flex-col flex-wrap gap-7 w-full sm:w-85",
})``;

const InfoContainer = styled.div.attrs({
  className: "flex flex-wrap gap-8 sm:gap-0",
})``;

const SingleContainerRight = styled.div.attrs({
  className: "flex flex-wrap gap-8 sm:gap-0 lg:justify-end mb-4",
})``;

const IndividualInfo = styled.div.attrs({
  className: "w-50 flex flex-col flex-wrap mb-4",
})``;

const Header = styled.div.attrs({
  className: "text-xs font-normal text-zinc-400 leading-4 w-44",
})``;

const SubHeader = styled.div.attrs({
  className: "text-sm font-semibold text-neutral-700 leading-5 w-44",
})``;

const Divider = styled.div.attrs({
  className: "bg-stone-300 h-fit h-px w-full lg:h-64 lg:w-px",
})``;

export default {
  ListItem,
  DatosContainer,
  InfoGrouping,
  InfoContainer,
  SingleContainerRight,
  IndividualInfo,
  Header,
  SubHeader,
  Divider,
};
